import { controls,grouped } from "../controls";
const queries = {
label: "Queries",
pageLabel: "Queries",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Code"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "query_code",maxlength:20}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Description",description:'Full partial search. e.g. You can search for Shivraj Deshmukh by typing raj or raj deshmuk.'}),
...controls.text({ tab: "filter",  placeHolder: "", name: "%query_display%",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Oro Client"}),
...controls.oc({ tab: "filter", c: "OROClient", placeHolder: "Oro Client Code", name: "Query-oro_client-oro_client_code",fastpath: "oro_clients"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "Query-oro_client-oro_client_display"}),
...controls.displayText({ tab: "filter", label: "Data Source"}),
...controls.oc({ tab: "filter", c: "DataSource", placeHolder: "Data Source Code", name: "Query-data_source-data_source_code",fastpath: "data_sources"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "Query-data_source-data_source_display"}),
...controls.displayText({ tab: "filter", label: "Query Type"}),
...controls.oc({ tab: "filter", c: "QueryType", placeHolder: "Query Type Code", name: "Query-query_type-query_type_code",fastpath: "query_types"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "Query-query_type-query_type_display"}),
...controls.checkBox({ tab: "filter",default:true, label: "Active", name: "query_active" }),
]
,form:[
...controls.displayText({ tab: "general", label: "Data Source",star:true}),
...controls.oc({ tab: "general", c: "DataSource", placeHolder: "Data Source Code", name: "data_source_code",isRequired:true,fastpath: "data_sources",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "data_source_display"}),
...controls.displayText({ tab: "general", label: "Query Type",star:true}),
...controls.oc({ tab: "general", c: "QueryType", placeHolder: "Query Type Code", name: "query_type_code",isRequired:true,fastpath: "query_types",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "query_type_display"}),
...controls.displayText({ tab: "general", label: "Code",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "query_code",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Description",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "query_display",isRequired:true,maxlength:50}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Oro Client",star:true}),
...controls.oc({ tab: "general", c: "OROClient", placeHolder: "Oro Client Code", name: "oro_client_code",isRequired:true,fastpath: "oro_clients" ,isReadOnly:"edit" ,hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "oro_client_display"}),
...controls.displayText({ tab: "general", label: "Query Text",width:"col-sm-12"}),
...controls.simpleeditor({ tab: "general",name: "query_text"}),
...controls.displayText({ tab: "general", label: "Note",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "note",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "general", label: "Dynamic Columns",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "dynamic_columns",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "Grouping",width:"col-sm-12"}),
...controls.simpleeditor({ tab: "general",name: "grouping"}),
...controls.checkBox({ tab: "general", label: "Active",default:false, name: "query_active" }),
]
,history:{
perPage: 10,
reportHeader: "Queries",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Query Code",accessor: "query_code",},
{Header: "Query",accessor: "query_display",},
{Header: "Data Source",accessor: "Query-data_source-data_source_display",},
{Header: "Query Type",accessor: "Query-query_type-query_type_display",},
{Header: "Query Active",accessor: "query_active",type:'tick'},
]}};
export default queries;